/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meta_Brand_TitleInputs */

const en_meta_brand_title = /** @type {(inputs: Meta_Brand_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brand — the mark, the palette and the type | Lindevo`)
};

const lv_meta_brand_title = /** @type {(inputs: Meta_Brand_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zīmols — zīme, palete un burtveidols | Lindevo`)
};

/**
* | output |
* | --- |
* | "Brand — the mark, the palette and the type \| Lindevo" |
*
* @param {Meta_Brand_TitleInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const meta_brand_title = /** @type {((inputs?: Meta_Brand_TitleInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meta_Brand_TitleInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_meta_brand_title(inputs)
	return en_meta_brand_title(inputs)
});